import React, { Component } from 'react';
import { getOwnerContract }  from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';

class BuyToken extends Component {

    state = {
    };

    async componentDidMount() {
      // window.googleTranslateElementInit = () => {
      //   new window.google.translate.TranslateElement(
      //     { pageLanguage: 'en' },
      //     'google_translate_element'
      //   );
      // };
  
      // // Add the script tag to the HTML document
      // const script = document.createElement('script');
      // script.src = 'http://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      // script.defer = true;
      // document.body.appendChild(script);

    }

    addToMetamask = async () => {
        try {
            // wasAdded is a boolean. Like any RPC method, an error may be thrown.
            const wasAdded = await window.ethereum.request({
              method: 'wallet_watchAsset',
              params: {
                type: 'ERC20', // Initially only supports ERC20, but eventually more!
                options: {
                  address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F', // The address that the token is at.
                  // address: '0xD6bdfA86136F8390C8513d27C2578fE7e54C89d8', // The address that the token is at.
                  symbol: 'USDT', // A ticker symbol or shorthand, up to 5 chars.
                  decimals: 6, // The number of decimals in the token
                    //   image: tokenImage, // A string url of the token logo
                },
              },
            });
          
            if (wasAdded) {
              console.log('Thanks for your interest!');
            } else {
              console.log('Your loss!');
            }
          } catch (error) {
            console.log(error);
          }
    }

    addBUSOToMetamask = async () => {
      try {
          // wasAdded is a boolean. Like any RPC method, an error may be thrown.
          const wasAdded = await window.ethereum.request({
            method: 'wallet_watchAsset',
            params: {
              type: 'ERC20', // Initially only supports ERC20, but eventually more!
              options: {
                address: '0x7E26081D41fD9a18a32b66268C8cC5c621eb1cF2', // The address that the token is at.
                // address: '0x7b89E846a430F0E4C220E0a7caf2D4dA0D6a777f', // The address that the token is at.
                symbol: 'BUSO', // A ticker symbol or shorthand, up to 5 chars.
                decimals: 6, // The number of decimals in the token
                  //   image: tokenImage, // A string url of the token logo
              },
            },
          });
        
          if (wasAdded) {
            console.log('Thanks for your interest!');
          } else {
            console.log('Your loss!');
          }
        } catch (error) {
          console.log(error);
        }
    }

    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ffff00" }}>IP Token: </span> <a href='https://app.uniswap.org/swap?chain=polygon&inputCurrency=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&outputCurrency=0x88CE5800627f8706edf085Bee4fB0bDAF45B8888&value=10000&field=output' target="_blank">Click to Buy</a>
                            </div>
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Whitepaper:</span> <a href='/IPToken_EN.pdf' target="_blank"> Click</a>
                            </div>
                          {/*  <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Whitepaper (ENG) :</span> <a href='https://drive.google.com/file/d/1JBJ5KJcfQ1bwdgRDMOZSgyjKJNqW4VDE/view?usp=sharing' target="_blank"> Click</a>
                            </div> */}
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Token Address :</span> <a href='https://polygonscan.com/token/0x88CE5800627f8706edf085Bee4fB0bDAF45B8888' target="_blank">0x88CE...B8888</a>
                            </div>
                             <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Total Supply: 500,000,000</span> 
                            </div>
                              <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Decimal: 6</span> 
                            </div>
                              <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Contract: Verified, Audited, burnable</span> 
                            </div>
                            {/*
                               <div className="text-lg sm:text-md">
                            <span style={{ color: "#00ffff" }}>Whitepaper (THA) :</span> <a href='https://drive.google.com/file/d/1rREfRqwWQXoxyFYtAbLWNZtBsMqzMDDZ/view?usp=sharing' target="_blank"> Click</a>
                            </div> */}
                          {/*  <div className="text-lg sm:text-md">
                            <span style={{ color: "#ffc107" }}>Burning Record: </span>
                            </div>        
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ff0000" }}>1st Burning: </span> <a href='https://polygonscan.com/tx/0x2e848fdd936fb6a3f2ab116e96aa459874d9df98644845361dd7cf4964c15013' target="_blank"> 1,000,000 IP</a>
                            </div>      
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ff0000" }}>2nd Burning: </span> <a href='https://polygonscan.com/tx/0x97900962386ab4416ca51f6b3adb4338bcbdde364ea2d94a156aa845b49e9f4a' target="_blank"> 1,000,000 IP</a>
                            </div>             
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#ff0000" }}>3rd Burning: </span> <a href='https://polygonscan.com/tx/0x6768bc174545fbf7d4e0b2c83fb2e06442bdc352876d6deacdc92b1076d3076e' target="_blank"> 1,000,000 IP</a>
                            </div>     
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>4th Burning: </span> <a href='https://polygonscan.com/tx/0x8045356f144a491a7978c4ba22cdec905ea9dbd0aa1ef4352ca5c56a22982a31' target="_blank"> 100,000,000 IP</a>
                            </div>   
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>5th Burning: </span> <a href='https://polygonscan.com/tx/0x8c7471037131005a9d8ed7912b1a664aa67bc07f118a57e3c71a4be7abb4feeb' target="_blank"> 100,000,000 IP</a>
                            </div>        
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>6th Burning: </span> <a href='https://polygonscan.com/tx/0xb74689e88e1ef2fa8135a0a4cb452073b490de7a3decd9249bc09a5546d49e22' target="_blank"> 1,000,000 IP</a>
                            </div>                
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>7th Burning: </span> <a href='https://polygonscan.com/tx/0xa65ed5eed5c2ec8cb8ef7a97d9192b129accbb84a4f6360aa63a6914ad9fa801' target="_blank"> 100,000,000 IP</a>
                            </div>        
                             <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>8th Burning: </span> <a href='https://polygonscan.com/tx/0x961c5d5137a42c7f7e35d11ff1f9e495505b0530912d03886ce3c28434c91001' target="_blank"> 100,000,000 IP</a>
                            </div>                    
                            <div className="text-lg sm:text-md">
                            <span style={{ color: "#F4D03F" }}>9th Burning: </span> <a href='https://polygonscan.com/tx/0xc6e193785d53f9f6d798d7f2e69d38ae0b7c21083c95925fd9196c14bf61cc94' target="_blank"> 96,000,000 IP</a>
                            </div> */}                
                        </div>
                    </div>
            </div>
        );
    }
}
 
export default withWrapper(BuyToken);